export enum InputType {
  TEXT = 'text',
  PASSWORD = 'password',
  FILE = 'file',
  NUMBER = 'number'
}

export enum API {
  REGISTER = '/register',
  LOGIN = '/login',
  REFRESH_TOKEN = '/refresh-token',
  LOGIN_WITH_TOKEN = '/login-with-token',
  NAME_UPDATE = '/update-name',
  PASSWORD_UPDATE = '/update-password',
  LOGOUT = '/logout',
  DASHBOARDS = '/dashboards',
  DASHBOARD_DETAILS = '/dashboards',
  DASHBOARD_UPDATE = '/dashboards',
  DASHBOARD_DELETE = '/dashboards',
  DASHBOARD_CREATE = '/dashboards/create',
  DASHBOARD_SEND = '/dashboards',
  WEBSITES = '/websites',
  WEBSITE_UPDATE = '/websites',
  WEBSITE_DELETE = '/websites',
  WEBSITE_DETAILS = '/websites',
  WEBSITE_CREATE = '/websites/create',
  SETUP_SAVE = '/setup',
  SOURCE_PATH = '/source-path',
  ICON_BASE_PATH = '/storage',
  SEND_FORGOT_PASSWORD_EMAIL = '/forgot-password',
  PASSWORD_RESET = '/reset-password',
  USERS = '/users',
  USER = '/users',
  PLAN_INFO = '/plan-info',
  CHECKOUT = '/checkout',
  SWITCH_PLAN = '/switch-plan',
  CONTACT = '/contact'
}

export enum AppRoute {
  REGISTER = '/register',
  LOGIN = '/login',
  SETUP = '/setup',
  PROFILE = '/profile',
  DASHBOARDS = '/dashboards',
  DASHBOARD_NEW = '/new-dashboard',
  DASHBOARD_EDIT = '/dashboard/:id',
  DASHBOARD_CREATED = '/created-dashboard',
  WEBSITES = '/websites',
  WEBSITE_NEW = '/new-website',
  WEBSITE_CREATED = '/created-website',
  WEBSITE_EDIT = '/website/:id',
  FORGOT_PASSWORD = '/forgot-password',
  PASSWORD_RESET = '/reset-password/:passwordResetToken',
  USERS = '/users',
  USER_EDIT = '/users/:id',
  UPGRADE = '/upgrade',
  ONBOARDING = '/onboarding',
  CONTACT_US = '/contact-us'
}

export enum ButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  GHOST = 'GHOST',
  PRIMARY_INVERSE = 'PRIMARY_INVERSE'
}

export enum SnackbarType {
  SUCCESS = 'success',
  ERROR = 'error'
}

export enum SidebarMenuItem {
  WEBSITES,
  DASHBOARDS,
  PROFILE,
  USER_MANAGEMENT,
  UPGRADE
}

export enum StatusType {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  OK = 'OK',
  NA = '-',
  IGNORE = 'NOT SET',
  UNAVAILABLE = 'UNAVAILABLE',
  IN_PROGRESS = 'IN_PROGRESS'
}

export enum MonitorAttribute {
  HTTP_STATUS = 'HTTP_STATUS',
  SSL_STATUS = 'SSL_STATUS',
  SITE_SPEED = 'SITE_SPEED',
  KEYWORD = 'KEYWORD'
}

export enum NoticeType {
  WARNING = 'WARNING',
  ERROR = 'ERROR'
}

export enum InputVariant {
  NORMAL,
  INLINE
}

export enum WebsiteHealthKey {
  HTTP_STATUS = 'httpStatus',
  KEYWORDS = 'keywords',
  LOAD_SPEED = 'loadSpeed',
  SSL_STATUS = 'sslStatus'
}

export enum WebsiteSettingKey {
  URL = 'url',
  NAME = 'name',
  DASHBOARDS = 'dashboardIds',
  HTTP_STATUS_RULE = 'httpStatusRule',
  HTTP_STATUS_CODE = 'httpStatusCode',
  KEYWORD_RULE = 'keywordRule',
  KEYWORDS = 'keywords',
  LOAD_TIME_ERROR = 'loadTimeError',
  SSL_EXPIRE_ERROR = 'sslExpireError',
  LOAD_TIME_WARNING = 'loadTimeWarning',
  SSL_EXPIRE_WARNING = 'sslExpireWarning',
  ACTIVE = 'active',
  ICON_PATH = 'iconPath'
}

export enum WebsiteSettingsOption {
  IS_ONE_OF = 'IS_ONE_OF',
  IS_NOT_ONE_OF = 'IS_NOT_ONE_OF',
  INCLUDES_KEYWORD = 'INCLUDES_KEYWORD',
  NOT_INCLUDES_KEYWORD = 'NOT_INCLUDES_KEYWORD',
  SECOND_1 = 'SECOND_1',
  SECOND_2 = 'SECOND_2',
  SECOND_3 = 'SECOND_3',
  SECOND_5 = 'SECOND_5',
  SECOND_10 = 'SECOND_10',
  EXPIRED = 'EXPIRED',
  DAYS_1 = 'DAYS_1',
  DAYS_2 = 'DAYS_2',
  DAYS_3 = 'DAYS_3',
  DAYS_5 = 'DAYS_5',
  DAYS_10 = 'DAYS_10'
}

export enum OverallHealth {
  OK = 'OK',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  UNKNOWN = 'UNKNOWN',
  UNAVAILABLE = 'UNAVAILABLE'
}

export enum UserRole {
  ADMIN = 'ADMIN',
  USER = 'USER'
}

export enum PillVariant {
  WARNING,
  ERROR
}

export enum WebsiteStatusSearch {
  ALL = 'ALL',
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  OK = 'OK',
  NA = 'NA',
  IGNORE = 'IGNORE',
  UNAVAILABLE = 'UNAVAILABLE',
  IN_PROGRESS = 'IN_PROGRESS'
}

export enum PlanType {
  FREE = 'FREE',
  PREMIUM_SMALL = 'PREMIUM_SMALL',
  PREMIUM_LARGE = 'PREMIUM_LARGE'
}
